/* eslint-disable no-fallthrough */
/* eslint-disable valid-typeof */
/* eslint-disable react/jsx-key */
import { Link } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import green from "@material-ui/core/colors/green";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import CloudUpload from "@material-ui/icons/CloudUpload";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import GetAppIcon from "@material-ui/icons/GetApp";
import Input from "@material-ui/icons/Input";
import Visibility from "@material-ui/icons/Visibility";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import datetimeHelper from "./../helper/datetime-helper";
import jsonHelper from "./../helper/json-helper";
import { globalHistory } from "./../history";

function desc(a, b, orderBy) {
  if (!b[orderBy]) b[orderBy] = "";
  if (!a[orderBy]) a[orderBy] = "";
  if (orderBy === "role") {
    if (b[orderBy] === "customer-manager.service") {
      b[orderBy] = "Quản lý";
    } else if (b[orderBy] === "telephonist.service") {
      b[orderBy] = "Điện thoại viên";
    }
    if (a[orderBy] === "customer-manager.service") {
      a[orderBy] = "Quản lý";
    } else if (b[orderBy] === "telephonist.service") {
      a[orderBy] = "Điện thoại viên";
    }
  }
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, rowItems } = this.props;

    return (
      <TableHead>
        <TableRow>
          {rowItems
            ? rowItems.map((row) => (
                <TableCell
                  key={row.id}
                  padding="default"
                  sortDirection={orderBy === row.id ? order : false}>
                  <Tooltip
                    title="Sort"
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}>
                    <TableSortLabel
                      active={orderBy === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id)}
                      style={{
                        fontSize: this.props.size === "small" ? "10px" : "auto",
                      }}>
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              ))
            : null}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  rowItems: PropTypes.array,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  add: {
    marginLeft: theme.spacing.unit * 3,
  },
});

let EnhancedTableToolbar = (props) => {
  const { classes } = props;

  return (
    <Toolbar style={{ backgroundColor: "#fafafa" }}>
      <div className={classes.title}>
        <Typography variant="h6" id="tableTitle">
          {props.nameTable}
        </Typography>
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {props.createAction ? props.createAction : null}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  nameTable: PropTypes.string,
  createAction: PropTypes.object,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  icon: {
    marginRight: 15,
  },
  input: {
    marginTop: theme.spacing.unit * 3,
    width: "100%",
  },
  valueColor: {
    paddingLeft: "1px",
  },
  color: {
    width: "36px",
    height: "14px",
    borderRadius: "2px",
  },
  swatch: {
    padding: "1px",
    background: "#fff",
    borderRadius: "1px",
    boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
    display: "inline-block",
    cursor: "pointer",
  },
  chip: {
    margin: theme.spacing.unit,
  },
  checkboxRoot: {
    color: green[600],
    "&$checked": {
      color: green[500],
    },
  },
  button: {
    fontWeight: "normal",
    fontStyle: "normal",
    fontSize: 13,
    padding: 0,
    alignItems: "center",
    display: "flex",
  },
  iconRight: {
    marginRight: theme.spacing.unit,
    fontSize: 20,
  },
});

class EnhancedTable extends React.Component {
  state = {
    order: "asc",
    orderBy: "calories",
    selected: [],
    data: [],
    page: 0,
    rowsPerPage: 20,
    isOpen: false,
    item: null,
    modalDelete: false,
    modalEdit: false,
    showPassword: false,
    rowSelect: [20, 40, 60, 80, 100],
  };

  componentDidMount() {
    this.history = globalHistory();
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  openModal(item) {
    this.state.item = item;
    this.setState({ isOpen: !this.state.isOpen });
  }

  openModalEdit(item) {
    this.state.item = item;
    this.setState({ modalEdit: !this.state.modalEdit });
  }

  openModalDelete(item) {
    this.state.item = item;
    this.setState({ modalDelete: !this.state.modalDelete });
  }

  handleClose = () => {
    this.setState({ isOpen: false, modalDelete: false });
  };

  handleCloseDetail = () => {
    this.setState({ modalEdit: false });
  };

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  render() {
    const {
      classes,
      nameTable,
      rowsName,
      items,
      rowsPerPage,
      count,
      handleChangePage,
      handleChangeRowsPerPage,
      page,
      rowItems,
    } = this.props;
    const { data, order, orderBy, selected, item } = this.state;
    return (
      <React.Fragment>
        <Paper className={classes.root}>
          {nameTable ? (
            <EnhancedTableToolbar
              nameTable={nameTable}
              createAction={this.props.createAction}
            />
          ) : (
            ""
          )}
          <div className={classes.tableWrapper}>
            <Table
              className={
                this.props.layout && this.props.layout === 6
                  ? null
                  : classes.table
              }
              style={{
                minWidth: this.props.size === "small" ? "400px" : "1020px",
              }}
              size={this.props.size === "small" ? "small" : "medium"}
              aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                size={this.props.size}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={data.length}
                rows={rowsName}
                rowItems={rowItems}
              />
              <TableBody>
                {stableSort(items, getSorting(order, orderBy)).map(
                  (item, key) => {
                    return (
                      <TableRow tabIndex={-1} key={key} hover>
                        {rowItems.map((col, keyRow) => {
                          let value = col.customValue
                            ? col.customValue(item)
                            : item[col.id];
                          if (col.label.indexOf(".") > 0) {
                            value = jsonHelper.getPropertyByString(
                              item,
                              col.label
                            );
                          }
                          const att = col._attributes;
                          if (att) {
                            if (value) {
                              value = value[att];
                              switch (att) {
                                case "Priority": {
                                  if (value == "Cao") {
                                    return (value = (
                                      <Chip
                                        label="Cao"
                                        className={classes.chip}
                                        style={{ backgroundColor: "#ef2a37" }}
                                      />
                                    ));
                                  }
                                  if (value == "Thấp") {
                                    return (value = (
                                      <Chip
                                        label="Thấp"
                                        className={classes.chip}
                                        style={{ backgroundColor: "#516cf0" }}
                                      />
                                    ));
                                  }
                                  if (value == "Trung bình") {
                                    return (value = (
                                      <Chip
                                        label="Trung bình"
                                        className={classes.chip}
                                        style={{ backgroundColor: "#ffc552" }}
                                      />
                                    ));
                                  }
                                  if (value == undefined) {
                                    return (value = (
                                      <TableCell
                                        className={classes.cell}
                                        key={keyRow}>
                                        {value}
                                      </TableCell>
                                    ));
                                  }
                                }
                                case "name": {
                                  if (value != undefined) {
                                    return (value = (
                                      <TableCell
                                        className={classes.cell}
                                        key={keyRow}>
                                        {value.name}
                                      </TableCell>
                                    ));
                                  }
                                }
                                case "user": {
                                  if (value != undefined) {
                                    return (value = (
                                      <TableCell
                                        className={classes.cell}
                                        key={keyRow}>
                                        {value.username}
                                      </TableCell>
                                    ));
                                  } else {
                                    return (value = "");
                                  }
                                }
                                case "Employee": {
                                  if (value != undefined) {
                                    return (value = (
                                      <TableCell
                                        className={classes.cell}
                                        key={keyRow}>
                                        {value.name}
                                      </TableCell>
                                    ));
                                  }
                                }
                                case "Tag": {
                                  let tags = value ? value.split(";") : [];
                                  if (
                                    typeof tags.isArray !== undefined &&
                                    tags.length !== 0
                                  ) {
                                    return (tags =
                                      tags.length > 2 ? (
                                        <React.Fragment>
                                          {tags.slice(0, 2).map((item, key) => {
                                            return (
                                              <Chip
                                                label={item}
                                                className={classes.chip}
                                                key={key}
                                              />
                                            );
                                          })}
                                          <Chip
                                            label={"..."}
                                            className={classes.chip}
                                          />
                                        </React.Fragment>
                                      ) : (
                                        tags.map((item, key) => {
                                          return (
                                            <Chip
                                              label={item}
                                              className={classes.chip}
                                              key={key}
                                            />
                                          );
                                        })
                                      ));
                                  }
                                  break;
                                }
                                case "lead": {
                                  if (value) {
                                    return (value = (
                                      <Checkbox
                                        checked={value.isLead}
                                        disabled
                                      />
                                    ));
                                  } else {
                                    return (value = (
                                      <Checkbox checked={false} disabled />
                                    ));
                                  }
                                }
                              }
                              // return (
                              //   value = (<TableCell className={classes.cell} key={keyRow}>{value}</TableCell>)
                              // )
                              // default: {
                              //   value = (<TableCell className={classes.cell} key={keyRow}>{value}</TableCell>)
                              //   break;
                              // }
                            }
                          }
                          if (value) {
                            switch (col.id) {
                              case "contactFile": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  value = `${value.name} - (${value.contacts.length} danh bạ)`;
                                }
                                break;
                              }
                              case "acd":
                              case "answeredDuration": {
                                value = datetimeHelper.secondToHHMMSS(value);
                                break;
                              }
                              case "createdAt": {
                                value = datetimeHelper.toFormat(
                                  value,
                                  "YYYY-MM-DD HH:mm:ss"
                                );
                                break;
                              }
                              case "endAt":
                              case "lastUpdate":
                              case "startAt":
                              case "startedAt": {
                                // if (item.recordFile) {
                                value = datetimeHelper.toFormat(
                                  value,
                                  "YYYY-MM-DD HH:mm:ss"
                                );
                                // }
                                // else {
                                // value = datetimeHelper.toFormat(value, "YYYY-MM-DD");
                                // }
                                break;
                              }
                              case "recallTime": {
                                if (value) {
                                  value = datetimeHelper.toFormat(
                                    value,
                                    "YYYY-MM-DD"
                                  );
                                }
                                break;
                              }
                              case "user": {
                                if (att && att === "username") {
                                  break;
                                }
                                value = value.fullname;
                                break;
                              }
                              case "role": {
                                if (value === "customer-manager.service") {
                                  value = "Quản lý";
                                } else if (value === "telephonist.service") {
                                  value = "Điện thoại viên";
                                }
                                break;
                              }
                              case "pbx": {
                                value = value.externalIp;
                                break;
                              }
                              case "agentView": {
                                value = <Checkbox checked={value} disabled />;
                                break;
                              }
                              case "topic":
                              case "knowledgeBase":
                              case "article": {
                                value = value.title;
                                break;
                              }
                              case "agents":
                              case "actions":
                              case "menuItems": {
                                if (
                                  this.props.nameTable ===
                                  "Danh sách giờ làm việc"
                                ) {
                                  if (
                                    typeof value.isArray !== undefined &&
                                    value.length !== 0
                                  ) {
                                    value =
                                      value.length > 2 ? (
                                        <React.Fragment>
                                          {value
                                            .slice(0, 2)
                                            .map((item, key) => {
                                              const arr = item.date.split(",");
                                              const str = arr
                                                .map(
                                                  (a) =>
                                                    a.charAt(0).toUpperCase() +
                                                    a.slice(1)
                                                )
                                                .join(",");
                                              return (
                                                <Chip
                                                  label={
                                                    str + " - " + item.time
                                                  }
                                                  className={classes.chip}
                                                  key={key}
                                                />
                                              );
                                            })}
                                          <Chip
                                            label={"..."}
                                            className={classes.chip}
                                          />
                                        </React.Fragment>
                                      ) : (
                                        value.map((item, key) => {
                                          const arr = item.date.split(",");
                                          const str = arr
                                            .map(
                                              (a) =>
                                                a.charAt(0).toUpperCase() +
                                                a.slice(1)
                                            )
                                            .join(",");
                                          return (
                                            <Chip
                                              label={str + " - " + item.time}
                                              className={classes.chip}
                                              key={key}
                                            />
                                          );
                                        })
                                      );
                                  }
                                  break;
                                }
                                if (
                                  typeof value.isArray === "undefined" &&
                                  value !== null
                                ) {
                                  value = value.length;
                                }
                                break;
                              }
                              case "source": {
                                if (value !== "outbound") {
                                  value = "Ticket Inbound";
                                } else {
                                  value = "Ticket Outbound";
                                }
                                break;
                              }
                              case "agent": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  if (value.user !== null) {
                                    value = `${value.user.username} - ${value.user.fullname}`;
                                  }
                                }
                                break;
                              }
                              case "isRunning": {
                                if (value == true) {
                                  value = (
                                    <Button
                                      size="small"
                                      className={classes.button}
                                      onClick={() =>
                                        this.props.handlePause(item)
                                      }>
                                      <Icon className={classes.iconRight}>
                                        play_arrow
                                      </Icon>
                                      Đang chạy
                                    </Button>
                                  );
                                } else {
                                  value = (
                                    <Button
                                      size="small"
                                      className={classes.button}
                                      onClick={() =>
                                        this.props.handlePlay(item)
                                      }>
                                      <Icon className={classes.iconRight}>
                                        pause
                                      </Icon>
                                      Tạm dừng
                                    </Button>
                                  );
                                }
                                break;
                              }
                              case "contact": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  value = (
                                    <Typography
                                      variant="body2"
                                      gutterBottom
                                      className={classes.button}
                                      onClick={
                                        typeof this.props.callNumber ===
                                        "function"
                                          ? () => this.props.callNumber(item)
                                          : ""
                                      }>
                                      <Icon className={classes.iconRight}>
                                        call
                                      </Icon>
                                      {value.phoneNumber}
                                    </Typography>
                                  );
                                }
                                break;
                              }
                              case "fromNumber":
                              case "to":
                              case "phoneNumber": {
                                value = (
                                  <Typography
                                    variant="body2"
                                    gutterBottom
                                    style={{ display: "flex" }}
                                    onClick={
                                      typeof this.props.callNumber ===
                                      "function"
                                        ? () => this.props.callNumber(item)
                                        : ""
                                    }>
                                    {/* <Button size="small" className={classes.button}> */}
                                    <Icon className={classes.iconRight}>
                                      call
                                    </Icon>
                                    {value}
                                  </Typography>
                                );
                                break;
                              }
                              case "extension": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  value =
                                    value.name || value.username
                                      ? `${value.name} - ${value.username}`
                                      : "";
                                }
                                break;
                              }
                              case "group":
                              case "campaign":
                              case "attributes":
                              case "form":
                              case "industry":
                              case "stage":
                              case "logsCount":
                              case "stageId": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  value = value.name;
                                } else if (value === "callback") {
                                  value = "Cần gọi lại";
                                } else if (value === "dnd") {
                                  value = "Không làm phiền";
                                } else if (value === "new") {
                                  value = "Trống";
                                } else if (value === "ni") {
                                  value = "Không có nhu cầu";
                                } else if (value === "nmq") {
                                  value = "Không đủ điều kiện";
                                } else if (value === "ptp") {
                                  value = "Tiềm năng";
                                } else if (value === "vm") {
                                  value = "Voice Mail";
                                } else if (value === "wr") {
                                  value = "Sai địa điểm";
                                } else if (
                                  value === "5e68a717da97f464b28aad5f"
                                ) {
                                  value = "Sai số điện thoại";
                                } else if (
                                  value === "5e8404b3af1a201bdf241b6b"
                                ) {
                                  value = "Không nghe máy";
                                } else if (
                                  value === "5e8404be1898d477725e09ea"
                                ) {
                                  value = "Nghe máy";
                                } else if (
                                  value === "5e8404c60e4e560e75908fca"
                                ) {
                                  value = "Tắt máy";
                                }
                                break;
                              }
                              case "org":
                              case "status":
                              case "ticketType": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  value = value.name;
                                } else if (value === "1" || value === true) {
                                  value = "Đang hoạt động";
                                } else if (value == "0" || value === false) {
                                  value = "Ngừng hoạt động";
                                }
                                break;
                              }
                              case "state": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  value = value.name;
                                } else if (value === 1) {
                                  value = "Đang hoạt động";
                                } else if (value == 0) {
                                  value = "Ngừng hoạt động";
                                }
                                break;
                              }
                              case "postOffice": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  value = `${value.id} - ${value.name}`;
                                }
                                break;
                              }
                              case "contacts": {
                                value = value.length;
                                break;
                              }
                              case "allocation": {
                                value = datetimeHelper.toFormat(
                                  value.createdAt,
                                  "YYYY-MM-DD"
                                );
                                break;
                              }
                              case "recordFileS3": {
                                if (
                                  item.recordFileS3 &&
                                  item.recordFileS3 !== "not-exists" &&
                                  !item.recordFileS3.includes("error")
                                ) {
                                  value = (
                                    <audio
                                      ref="audio"
                                      src={item.recordFileS3}
                                      controls
                                      autoPlay={false}
                                    />
                                  );
                                } else if (item.recordFile) {
                                  value = (
                                    <audio
                                      ref="audio"
                                      src={item.recordFile}
                                      controls
                                      autoPlay={false}
                                    />
                                  );
                                }
                                break;
                              }
                              case "fileName":
                              case "startSoundFile":
                              case "invalidSoundFile":
                                // let basicUrl = 'https://api-connect.io/media-mgt/container/ivrs/download/';
                                let basicUrl = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}/media-mgt/container/ivrs/download/`;
                                {
                                  value = (
                                    <audio
                                      ref="audio"
                                      src={basicUrl.concat(value)}
                                      controls
                                      autoPlay={false}
                                    />
                                  );
                                  break;
                                }
                              case "icon": {
                                value = <Icon>{value}</Icon>;
                                break;
                              }
                              case "note": {
                                value =
                                  value.length > 125
                                    ? `${value.substr(0, 125)}...`
                                    : value;
                                break;
                              }
                              case "defaultValue": {
                                value = datetimeHelper.secondToHHMMSS(
                                  value.toString().replace(/[^0-9]/g, "")
                                );
                                break;
                              }
                              case "tags": {
                                if (
                                  typeof value.isArray !== undefined &&
                                  value.length !== 0
                                ) {
                                  value =
                                    value.length > 2 ? (
                                      <React.Fragment>
                                        {value.slice(0, 2).map((item, key) => {
                                          return (
                                            <Chip
                                              label={item}
                                              className={classes.chip}
                                              key={key}
                                            />
                                          );
                                        })}
                                        <Chip
                                          label={"..."}
                                          className={classes.chip}
                                        />
                                      </React.Fragment>
                                    ) : (
                                      value.map((item, key) => {
                                        return (
                                          <Chip
                                            label={item}
                                            className={classes.chip}
                                            key={key}
                                          />
                                        );
                                      })
                                    );
                                }
                                break;
                              }
                              case "codeParcel": {
                                value = (
                                  <Link
                                    style={{
                                      textDecoration:
                                        this.props.selectedParcel === item.code
                                          ? "underline"
                                          : "none",
                                      color:
                                        this.props.selectedParcel === item.code
                                          ? "#3498db"
                                          : "",
                                    }}
                                    onClick={() =>
                                      this.props.handleSelectParcel(item)
                                    }>
                                    {item.code}
                                  </Link>
                                );
                                break;
                              }
                              case "url": {
                                value = (
                                  <Tooltip title={value}>
                                    <Icon>touch_app</Icon>
                                  </Tooltip>
                                );
                                break;
                              }
                              case "members": {
                                value = value.map((item) => {
                                  return (
                                    <Chip
                                      label={item.name}
                                      className={classes.chip}
                                    />
                                  );
                                });
                                break;
                              }
                              case "listAgent": {
                                if (value.length != 0) {
                                  value = value.map((item) => {
                                    return (
                                      <Chip
                                        label={item.code}
                                        className={classes.chip}
                                      />
                                    );
                                  });
                                }
                                break;
                              }
                              case "isPublished": {
                                if (value == true) {
                                  value = (
                                    <Checkbox
                                      checked={value}
                                      classes={{
                                        // root: classes.checkboxRoot,
                                        checked: classes.checked,
                                      }}
                                      color="primary"
                                    />
                                  );
                                } else {
                                  value = <Checkbox />;
                                }
                                break;
                              }
                              case "isNew": {
                                if (value === true) {
                                  value = (
                                    <Checkbox
                                      checked={value}
                                      classes={{
                                        // root: classes.checkboxRoot,
                                        checked: classes.checked,
                                      }}
                                      color="primary"
                                    />
                                  );
                                } else {
                                  value = false;
                                }
                                break;
                              }
                              case "color": {
                                value = (
                                  <React.Fragment>
                                    <div className={classes.swatch}>
                                      <div
                                        className={classes.color}
                                        style={{ background: `${value}` }}
                                      />
                                    </div>
                                    <div className={classes.valueColor}>
                                      {value}
                                    </div>
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "orgId": {
                                value = (
                                  <React.Fragment>
                                    <Tooltip title="Chỉnh sửa dữ liệu">
                                      <EditIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleEdit(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Xóa dữ liệu">
                                      <DeleteIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleDelete(item)
                                        }
                                      />
                                    </Tooltip>
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "mno": {
                                if (
                                  typeof value === "object" &&
                                  value !== null
                                ) {
                                  value = value.name;
                                } else if (value === "gpc") {
                                  value = "Vinaphone";
                                } else if (value === "viettel") {
                                  value = "Viettel";
                                } else if (value === "vms") {
                                  value = "Mobifone";
                                } else if (value === "gtel") {
                                  value = "GMobile";
                                } else if (value === "itel") {
                                  value = "Indochina Telecom";
                                } else if (value === "vnm") {
                                  value = "Vietnam Mobile";
                                } else if (value === "fixed") {
                                  value = "Cố định";
                                }
                                break;
                              }
                              case "isActive": {
                                value = (
                                  <Checkbox checked={item.isActive} disabled />
                                );
                                break;
                              }
                              case "title": {
                                if (
                                  this.props.nameTable ==
                                    "Danh sách giờ làm việc" &&
                                  value.length > 50
                                ) {
                                  value = value.substring(0, 50) + "...";
                                }
                                break;
                              }
                              case "name": {
                                if (value.length > 50) {
                                  value = value.substring(0, 50) + "...";
                                }
                                break;
                              }
                              case "ip": {
                                value =
                                  value && item.port
                                    ? value + ":" + item.port
                                    : value;
                                break;
                              }
                              case "updatedAt": {
                                value =
                                  moment(value).format("DD/MM/YYYY HH:mm");
                                console.log(value, 123);
                                break;
                              }
                            }
                          } else {
                            switch (col.id) {
                              case "pbx": {
                                value = "";
                                break;
                              }
                              case "agentView": {
                                value = <Checkbox checked={false} disabled />;
                                break;
                              }
                              case "source": {
                                if (
                                  value !== "outbound" ||
                                  value === "" ||
                                  value === undefined
                                ) {
                                  value = "Ticket Inbound";
                                } else {
                                  value = "Ticket Outbound";
                                }
                                break;
                              }
                              case "orgId": {
                                value = (
                                  <Tooltip title="Chỉnh sửa dữ liệu">
                                    <EditIcon
                                      className={classes.icon + " hover-cursor"}
                                      onClick={() =>
                                        this.props.handleEdit(item)
                                      }
                                    />
                                  </Tooltip>
                                );
                                break;
                              }
                              case "acd":
                              case "answeredDuration": {
                                value = datetimeHelper.secondToHHMMSS(value);
                                break;
                              }
                              case "isRunning": {
                                value = (
                                  <Button
                                    size="small"
                                    className={classes.button}
                                    onClick={() => this.props.handlePlay(item)}>
                                    <Icon className={classes.iconRight}>
                                      pause
                                    </Icon>
                                    Tạm dừng
                                  </Button>
                                );
                                break;
                              }
                              case "action": {
                                value = this.props.allowEdit ? (
                                  <Tooltip title="Chỉnh sửa dữ liệu">
                                    <EditIcon
                                      className={classes.icon + " hover-cursor"}
                                      onClick={() =>
                                        this.props.handleEdit(item)
                                      }
                                    />
                                  </Tooltip>
                                ) : (
                                  <React.Fragment>
                                    <Tooltip title="Chỉnh sửa dữ liệu">
                                      <EditIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleEdit(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Xóa dữ liệu">
                                      <DeleteIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleDelete(item)
                                        }
                                      />
                                    </Tooltip>
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "actionClone": {
                                value = (
                                  <React.Fragment>
                                    <Tooltip title="Chỉnh sửa dữ liệu">
                                      <EditIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleEdit(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Xóa dữ liệu">
                                      <DeleteIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleDelete(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Sao chép dữ liệu">
                                      <FileCopyIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleClone(item)
                                        }
                                      />
                                    </Tooltip>
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "configGetMoreAction": {
                                value = (
                                  <React.Fragment>
                                    {item.type === "data" && (
                                      <Tooltip
                                        title="Phân bổ thêm vào chiến dịch"
                                        placement="right">
                                        <Input
                                          className={classes.icon}
                                          onClick={() =>
                                            this.props.handleConfigGetMore(item)
                                          }
                                        />
                                      </Tooltip>
                                    )}
                                    <Tooltip
                                      title="Xóa lần phân bổ"
                                      placement="right">
                                      <Icon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleReload(item)
                                        }>
                                        cached
                                      </Icon>
                                    </Tooltip>
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "actionUpload": {
                                value = (
                                  <React.Fragment>
                                    <Tooltip title="Chỉnh sửa dữ liệu">
                                      <EditIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleEdit(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Xóa dữ liệu">
                                      <DeleteIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleDelete(item)
                                        }
                                      />
                                    </Tooltip>
                                    <IconButton
                                      aria-label="Upload"
                                      type="submit"
                                      className={" hover-cursor"}
                                      onClick={() => {
                                        this.setState((this.state.item = item));
                                        this.fileUpload.click(item);
                                      }}>
                                      <CloudUpload />
                                    </IconButton>
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "actionDownload": {
                                value = (
                                  <React.Fragment>
                                    <Tooltip title="Chỉnh sửa dữ liệu">
                                      <EditIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleEdit(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Xóa dữ liệu">
                                      <DeleteIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleDelete(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Tải dữ liệu">
                                      <GetAppIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleDownload(item)
                                        }
                                      />
                                    </Tooltip>
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "actionDownloadCampaign": {
                                value = (
                                  <React.Fragment>
                                    <Tooltip title="Chỉnh sửa dữ liệu">
                                      <EditIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleEdit(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Xóa dữ liệu">
                                      <DeleteIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleDelete(item)
                                        }
                                      />
                                    </Tooltip>
                                    {item.interactiveLogCount &&
                                    item.interactiveLogCount > 0 ? (
                                      <Tooltip title="Tải dữ liệu">
                                        <GetAppIcon
                                          className={
                                            classes.icon + " hover-cursor"
                                          }
                                          onClick={() =>
                                            this.props.handleDownload(item)
                                          }
                                        />
                                      </Tooltip>
                                    ) : null}
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "config": {
                                value = (
                                  <React.Fragment>
                                    <Tooltip title="Chỉnh sửa dữ liệu">
                                      <EditIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleEdit(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip title="Xóa dữ liệu">
                                      <DeleteIcon
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleDelete(item)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip
                                      title="Phân bổ vào chiến dịch"
                                      placement="right">
                                      <Input
                                        className={
                                          classes.icon + " hover-cursor"
                                        }
                                        onClick={() =>
                                          this.props.handleConfig(item)
                                        }
                                      />
                                    </Tooltip>
                                  </React.Fragment>
                                );
                                break;
                              }
                              case "setDefault": {
                                value = (
                                  <Checkbox
                                    checked={
                                      this.props.checkbox
                                        ? this.props.checkbox.id == item.id
                                          ? this.props.checkbox.id
                                          : null
                                        : null
                                    }
                                    onChange={() =>
                                      this.props.handleSetDefault(item)
                                    }
                                    value={this.props.checkbox}
                                  />
                                );
                                break;
                              }
                              case "view": {
                                value = (
                                  <Visibility
                                    className={classes.icon + " hover-cursor"}
                                    onClick={() => this.props.handleView(item)}
                                  />
                                );
                                break;
                              }
                              case "reload": {
                                value = (
                                  <Visibility
                                    className={classes.icon + " hover-cursor"}
                                    onClick={() =>
                                      this.props.handleReload(item)
                                    }
                                  />
                                );
                                break;
                              }
                              case "actionEdit": {
                                value = (
                                  <Tooltip title="Chỉnh sửa dữ liệu">
                                    <EditIcon
                                      className={classes.icon + " hover-cursor"}
                                      onClick={() =>
                                        this.props.handleEdit(item)
                                      }
                                    />
                                  </Tooltip>
                                );
                                break;
                              }
                              case "actionEditAndViewTicket": {
                                value = (
                                  <>
                                    <Visibility
                                      className={classes.icon + " hover-cursor"}
                                      onClick={() =>
                                        this.props.handleView(item)
                                      }
                                    />
                                    {item.ticketType &&
                                      item.ticketType.id ===
                                        "5f145e337d243d55d4614b8e" && // Khác hỗ trợ điểm bán
                                      item.attributes.Status !==
                                        "Đã hoàn thành" && (
                                        <Tooltip title="Chỉnh sửa dữ liệu">
                                          <EditIcon
                                            className={
                                              classes.icon + " hover-cursor"
                                            }
                                            onClick={() =>
                                              this.props.handleEdit(item)
                                            }
                                          />
                                        </Tooltip>
                                      )}
                                  </>
                                );
                                break;
                              }
                              case "actionPhoneNumber": {
                                value = (
                                  <>
                                    {
                                      <Tooltip title="Chỉnh sửa dữ liệu">
                                        <EditIcon
                                          className={
                                            classes.icon + " hover-cursor"
                                          }
                                          onClick={() =>
                                            this.props.handleEdit(item)
                                          }
                                        />
                                      </Tooltip>
                                    }
                                  </>
                                );
                                break;
                              }
                              case "subOrgNamePostmanCalls": {
                                value = item?.attributes?.province?.name
                                  ? item?.attributes?.province?.name
                                  : "";
                                break;
                              }
                              case "isActive": {
                                value = (
                                  <Checkbox checked={item.isActive} disabled />
                                );
                                break;
                              }
                              case "recordFileS3": {
                                if (
                                  item.recordFileS3 &&
                                  item.recordFileS3 !== "not-exists" &&
                                  !item.recordFileS3.includes("error")
                                ) {
                                  value = (
                                    <audio
                                      ref="audio"
                                      src={item.recordFileS3}
                                      controls
                                      autoPlay={false}
                                    />
                                  );
                                } else if (item.recordFile) {
                                  value = (
                                    <audio
                                      ref="audio"
                                      src={item.recordFile}
                                      controls
                                      autoPlay={false}
                                    />
                                  );
                                }
                                break;
                              }
                            }
                          }
                          return (
                            <TableCell
                              className={classes.cell}
                              style={{
                                fontSize:
                                  this.props.size === "small" ? "10px" : "14px",
                              }}
                              key={keyRow}>
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
            <input
              type="file"
              ref={(fileUpload) => {
                this.fileUpload = fileUpload;
              }}
              style={{ visibility: "hidden" }}
              onChange={(e) => {
                this.props.handleUpload(item.id, e.target.files[0]);
              }}
            />
          </div>
          {this.props.pagination == true ? (
            <TablePagination
              rowsPerPageOptions={
                this.props.rowSelectData.length !== 0
                  ? this.props.rowSelectData
                  : this.state.rowSelect
              }
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          ) : null}
        </Paper>
      </React.Fragment>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  nameTable: PropTypes.string.isRequired,
  rowsName: PropTypes.array,
  items: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleSelectParcel: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  handleDelete: PropTypes.func,
  handleUpload: PropTypes.func,
  handleEdit: PropTypes.func,
  handleConfig: PropTypes.func,
  rowItems: PropTypes.array.isRequired,
  createAction: PropTypes.bool,
  allowEdit: PropTypes.bool,
  allowDelete: PropTypes.bool,
  handleCreate: PropTypes.func,
  pagination: PropTypes.bool,
  handleView: PropTypes.func,
  handleSetDefault: PropTypes.func,
  handleConfigGetMore: PropTypes.func,
  handleReload: PropTypes.func,
  handleDownload: PropTypes.func,
  rowSelectData: PropTypes.array,
  layout: PropTypes.number,
  callNumber: PropTypes.func,
};

EnhancedTable.defaultProps = {
  items: [],
  rowItems: [],
  pagination: true,
  rowSelectData: [],
  layout: 12,
};

// EnhancedTable = connect(null, mapActionsToProps)(EnhancedTable);

export default withStyles(styles)(EnhancedTable);
